import { BlogDetailComponent } from './blogs/blog-detail/blog-detail.component';
import { BlogsComponent } from './blogs/blogs/blogs.component';
import { RouterModule } from '@angular/router';
import { PrivacySecurityComponent } from './privacy-security/privacy-security.component';
import { DistanceSellingContractComponent } from './distance-selling-contract/distance-selling-contract.component';
import { CancelPaymentComponent } from './cancel-payment/cancel-payment.component';
import { SoftwareServicesComponent } from './software-services/software-services.component';
import { ReferenceProjectsComponent } from './reference-projects/reference-projects.component';
import { ReferenceCompaniesComponent } from './reference-companies/reference-companies.component';
import { PersonelConsultantComponent } from './personel-consultant/personel-consultant.component';
import { CompanyConsultantComponent } from './company-consultant/company-consultant.component';
import { CareersComponent } from './careers/careers.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SiteComponent } from './site.component';
import { ContactComponent } from './contact/contact.component';
import { HomeComponent } from './home/home.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule} from '@angular/forms';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {SiteRoutingModule} from'./site-routing.module';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

@NgModule({
  declarations: [SiteComponent,HomeComponent,AboutUsComponent,CareersComponent,BlogsComponent,BlogDetailComponent,
    CompanyConsultantComponent,ContactComponent,PersonelConsultantComponent,ReferenceCompaniesComponent,ReferenceProjectsComponent,
   PrivacySecurityComponent,  SoftwareServicesComponent,CancelPaymentComponent,DistanceSellingContractComponent
  ],
  imports: [
    CommonModule,RouterModule,AutocompleteLibModule,
    SiteRoutingModule,FormsModule,
  ],schemas:[NO_ERRORS_SCHEMA], providers: [{provide: APP_BASE_HREF, useValue: '/'},{provide: LocationStrategy, useClass: PathLocationStrategy}]
})
export class SiteModule { }
